export default function handleTabIndex(tabIndex, nextTab) {
    if (tabIndex >= 0 || nextTab >= 0) {
        const inx = !!nextTab ? parseInt(nextTab) : (parseInt(tabIndex) + 1);
        let element = document.querySelector(`[tabindex="${inx}"]`);

        if (!element && !nextTab) {
            for (var i = 1; i <= 100; i++) {
                element = document.querySelector(`[tabindex="${inx + i}"]`);
                if (!!element)
                    break;
            }
        }

        if (element == null)
            return;

        try { element.focus(); } catch (err) { console.error(err); }
        try { element.select(); } catch (err) { console.error(err); }
    }
}